module.exports = __webpack_public_path__ + "static/media/fortaleza-ce.3f867e93.jpg";